
define('text!modules/reporting/campaigns/siteTransparency/templates/siteTransparency.html',[],function () { return '<div class="w-panel-body w-site-transparency-panel"></div>\n';});

